export function loginLocation (to) {
  return {
    path: to.meta.loginPath || '/agra/login',
    query: { redirect: to.fullPath }
  };
}

export function sessionRedirect (to, { member, token }) {
  const { authorize, requiredSubId } = to.meta;
  if (!authorize?.length) return null;
  if (!member || !token?.accessToken ||
      (requiredSubId && Number(member.subId) !== requiredSubId)) {
    return loginLocation(to);
  }
  if (!authorize.includes(member.role)) {
    return { path: requiredSubId === 4 ? '/watersupply' : '/agra' };
  }
  return null;
}

// Only accept a real protected route in the system that just logged in.
export function loginDestination (router, redirect, subId, fallback) {
  if (typeof redirect !== 'string' || !redirect.startsWith('/') ||
      redirect.startsWith('//') || /[\\\u0000-\u0020]/.test(redirect)) return fallback;
  try {
    const resolved = router.resolve(redirect);
    if (resolved.matched.length && resolved.meta.authorize?.length &&
        resolved.meta.requiredSubId === subId) return resolved.fullPath;
  } catch {
    // Malformed or unknown destinations use the system's home page.
  }
  return fallback;
}
